<template>

    <div class="modal__overlay">

        <div class="modal-editHTML" v-show="!selectContent.show">

            <div class="header">
                <h4>{{ props.content.id ? 'Editar' : 'Crear' }} redirección</h4>
                <i class="material-icons" @click.stop="emit('close')">close</i>
            </div>

            <div>
                <span class="btn-select-content" @click="selectContent.show = true">
                    {{ !selectContent.selected ? 'Seleccionar contenido' : 'Cambiar contenido seleccionado' }}
                </span>
            </div>

            <div class="editor-container">
                <TinyMCE 
                    :content="content"
                    ref="tinyEditor"
                />
            </div>

            <div v-if="selectContent.noSelection" class="invalid-warning"><i class="material-icons">error_outlined</i>Debes seleccionar un contenido</div>

            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')">Cancelar</button>
                <button class="confirm" @click.stop="save()" :disabled="saving || selectContent.noSelection">Guardar</button>
            </div>

        </div>

        <div class="select-content" v-if="selectContent.show">
            <div class="header">
                <h4>Seleccionar contenido para redirigir</h4>
                <i class="material-icons" @click.stop="selectContent.show = false">close</i>
            </div>

            <div class="select-content__tree">
                <div class="unit" v-for="unit in courseTree.units" :key="unit.unitOrderNumber">
                    <span @click="unit.expand ? unit.expand = false : unit.expand = true">Unidad {{ unit.unitOrderNumber }} <i class="material-icons">{{ unit.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i></span>
                    <div class="modules" v-if="unit.expand">
                        <div class="module" v-for="module in unit.modules" :key="module.moduleOrderNumber">
                            <span @click="module.expand ? module.expand = false : module.expand = true">{{ module.moduleName }}<i class="material-icons">{{ module.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</i></span>
                            <div class="contents" v-if="module.expand">
                                <template v-for="content in module.contents" :key="content.contentId">
                                    <span class="content" @click="selectContent.selected = content.contentId; selectContent.noSelection = false">{{ $t(`global.${content.contentType.toUpperCase()}`) }} 
                                        <i class="checkbox" ><i class="material-icons" v-if="selectContent.selected == content.contentId">check</i></i>
                                    </span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="buttons">
                <!-- disabled if no content selected from tree -->
                <button class="button button__forward" @click="selectContent.show = false" :disabled="!selectContent.selected">Confirmar selección</button>
            </div>


        </div>

    </div>

</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import defaultContents from "./defaultContents.js";
import TinyMCE from '@/components/TinyMCE.vue';

const store = useStore();
const route = useRoute();
const props = defineProps({
    content: Object
});
const emit = defineEmits(['close','reload']);

const tinyEditor = ref(null);
const courseTree = ref(null)
const saving = ref(false);

const selectContent = ref({
    show: false,
    selected: null
});

const obtainContent = (tag, text) => {
    let open = `[BEGIN_${tag}]`;
    let close = `[END_${tag}]`;
    let begin = text.indexOf(open) + open.length;
    let end = text.indexOf(close);

    if (begin !== -1 && end !== -1) {
        return text.substring(begin, end);
    } else {
        return null; // La etiqueta no fue encontrada
    }
}


const content = ref(props.content.id ? obtainContent('ENUNCIADO', props.content.data.Data) || '' : defaultContents.find(cont => cont.id == 'shortcut').content)


const save = async ()=> { 
    if(!selectContent.value.selected){
        selectContent.value.noSelection = true;
        return;
    }
    saving.value = true;
    let model = props.content;
    model.data.RedirectContentCfgId = selectContent.value.selected;
    let enunciado = `[BEGIN_ENUNCIADO]${tinyEditor.value.editorInstance.getContent()}[END_ENUNCIADO]`;
    let button = `[BEGIN_BOTON]<div style="font-family:'Open Sans',sans-serif; margin-top:12px;"><a class="btn-acceso-directo" href="" style="width:fit-content; padding:12px 40px; display:flex; align-items:center; justify-content:center; gap:4px; border-radius:30px; font-size:16px; font-weight:400; background-color:#009696; color:#fff; text-decoration:none;">Ir al contenido<i class="material-icons" style="font-size:16px;">arrow_forward</i></a></div>[END_BOTON]`;
    model.data.Data = enunciado+button;
    try {
        model.id
            ? await store.dispatch('contentEditor_editContent', model)
            : await store.dispatch('contentEditor_createContent', model);
        emit('reload');
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', {text: 'Error al intentar guardar contenido'});
    } finally {
        saving.value = false;
    }
}

async function getCourseTree(){
    let req = await store.dispatch('contentEditor_courseTree', route.params.courseCfgId);
    courseTree.value = req.data;
}

onMounted(()=>{
    getCourseTree();
    if(props.content.id){
        selectContent.value.selected = props.content.data.RedirectContentCfgId;
    } 
})

/* const courseTree = ref([
{
    id: 1,
    orderNumber: 1,
    modules: [
    { 
        id: 11,
        orderNumber: 1,
        name: 'modulo 1',
        contents: [
        { 
            id: 111,
            type: 'Actividad',
          },
          { 
            id: 112,
            type: 'Foro',
          }
        ]
      },
      { 
        id: 12,
        orderNumber: 1,
        name: 'modulo 1',
        contents: [
        { 
            id: 121,
            type: 'Actividad',
          },
          { 
            id: 122,
            type: 'Foro',
          }
        ]
      },
    ]
  },
  {
    id: 2,
    orderNumber: 1,
    modules: [
      { 
        id: 21,
        orderNumber: 1,
        name: 'modulo 1',
        contents: [
        { 
            id: 211,
            type: 'Actividad',
          },
          { 
            id: 212,
            type: 'Foro',
          }
        ]
      }
    ]
  },
]) */


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.modal__overlay{
    z-index: 1 !important;
}

@mixin modal{
    width: 96%;
    max-width: 800px;
    max-height: 82vh;
    padding: 22px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 22px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
}
@mixin modalHeader{
    padding-bottom: 6px;
    display: flex;
    justify-content: space-between;
    h4{
        padding-left: 4px;
    }
    i{
        cursor: pointer;
    }
}

.modal-editHTML{
    @include modal;
    .header{
        @include modalHeader;
    }
    .btn-select-content{
        padding: 4px 12px;
        border: 1px solid $green;
        border-radius: 20px;
        font-size: 13px;
        color: $green;
        font-weight: 600;
        cursor: pointer;
    }
    .invalid-warning{
        margin-bottom: -16px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        color: red;
        font-weight: 500;
        font-size: 14px;
        .material-icons{
            font-size: 21px;
            width: 21px;
        }
    }
    .modal__buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        .cancel{
            border: none;
        }
    }
}

.select-content{
    @include modal;
    .header{
        @include modalHeader;
    }
    &__tree{
        span{
            //width: fit-content;
            display: flex;
            align-items: center;
            gap: 6px;
            font-size: 14px;
            cursor: pointer;
        }
        .unit{
            margin-bottom: 12px;
            padding: 10px;
            box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.5);
            font-weight: 700;
        }
        .modules, .contents{
            padding-left: 24px;
            span{
                width: fit-content;
            }
        }
        .module{
            margin: 4px 0;
            font-weight: 600;
            font-size: 13px;
        }
        .content{
            margin: 6px 0;
            font-weight: 400;
            gap: 10px;
            .checkbox{
                width: 17px;
                height: 17px;
                border: 1px solid;
                display: flex;
                justify-content: center;
                align-items: center;
                .material-icons{
                    font-size: 15px;
                }
            }
        }
    }

    .buttons{
        display: flex;
        align-items: center;
        gap: 12px;
        justify-content: center;

        .button {
            text-align: center;
            width: fit-content;
            display: flex;
            align-items: center;
            gap: 12px;
            border-radius: 999px;
            padding: 12px 18px;

            &__forward {
            @extend .button;
            color: #fff;
            background-color: $green;
            &:disabled{
                cursor: default;
                opacity: .6;
            }
            }

            &__backward {
            @extend .button;
            border: 1px solid $green;
            color: $green;
            background-color: inherit;
            }
        }
    }
}

</style>